// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b2aac859","897":"225e1a58"}[chunkId] + ".chunk.js";
};